import request from '@/router/axios'

const pre_fix = "/dotadmin/dotadmin/pe/"


export function getTJInfo(id) {
  return request({
    url: pre_fix+'tj/'+id,
    method: 'get'
  })
}

export function pageTask(query) {
  return request({
    url: pre_fix+'task/page',
    method: 'get',
    params: query
  })
}


export function detailTask(id) {
  return request({
    url: pre_fix+'task/detail/'+id,
    method: 'get',
  })
}


export function peStart(flowInfo) {
  return request({
    url: pre_fix+'start/'+flowInfo.flowId,
    method: 'post',
    data: flowInfo
  })
}


export function getRecommendTime(flowInfo) {
  return request({
    url: pre_fix+'getRecommendTime/'+flowInfo.flowId,
    method: 'post',
    data: flowInfo
  })
}




export function check(flowId) {
  return request({
    url: pre_fix + 'check/' + flowId,
    method: 'get',
  })
}

export function finish(flowId) {
  return request({
    url: pre_fix + 'finish/' + flowId,
    method: 'post',
  })
}





